import { useMutation, useQueryClient } from "@tanstack/react-query";
import { userApi } from "../services/user.api";
import {
  errorNotification,
  successNotification,
} from "../../../utils/notification";
import {
  USER_MESSAGES_ERROR,
  USER_MESSAGES_SUCCESS,
} from "../constants/messages";

export const useEnableUser = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (id: string) => userApi.enable(id),
    onSuccess: (res) => {
      if (!res.ok) {
        errorNotification(USER_MESSAGES_ERROR.ENABLE_ERROR);
        return;
      }
      successNotification(USER_MESSAGES_SUCCESS.ENABLE_SUCCESS);
      queryClient.invalidateQueries({ queryKey: ["users"] });
    },
    onError: () => {
      errorNotification(USER_MESSAGES_ERROR.ENABLE_ERROR);
    },
  });
};

export const useDisableUser = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (id: string) => userApi.disable(id),
    onSuccess: (res) => {
      if (!res.ok) {
        errorNotification(USER_MESSAGES_ERROR.DISABLE_ERROR);
        return;
      }
      successNotification(USER_MESSAGES_SUCCESS.DISABLE_SUCCESS);
      queryClient.invalidateQueries({ queryKey: ["users"] });
    },
    onError: () => {
      errorNotification(USER_MESSAGES_ERROR.DISABLE_ERROR);
    },
  });
};
